import { render, staticRenderFns } from "./TsaChart.vue?vue&type=template&id=1c6f263c"
import script from "./TsaChart.vue?vue&type=script&lang=js"
export * from "./TsaChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports